module.exports = __webpack_public_path__ + "img/main_menu_hover_6.cf7fe913.png";